import React from 'react';
import EventEmitter from '../../../utils/emmiter';
import {UserContext} from '../../../utils/usercontext';
import {useracc, postApi} from '../../../utils/functions';

import VideoPlayer from '../video/video';
import Chatbox from '../messenger/chatbox';
import Genres from '../genres/genres';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import './livestream.css'


export default class EmbedLiveStream extends React.Component {
	static contextType = UserContext;
  constructor(props) {
		super(props);
		this.state = {
			service: {
				status: false,
				id: props.embed.id,
				name: props.embed.name || '',
        avatar: '',
			},
			//embed: props.embed,

      stage: {
				select: 10,
        live: {},
        poster: {},
				rtmp: {},
        viewers: []
			},
			stage_temp: {
        select: 10,
        live: {},
        poster: {},
				rtmp: {}
				/*select: 10,
				source: '/images/live/stream.jpg',*/
			},

      livetimestamp: '0:00:00',
      PortalStage: null,

      videoPlaying: false,
			showTooltip: false,
		};
    this.onError = this.onError.bind(this);
    this.isPlaying = this.isPlaying.bind(this);
	}

	async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${value.worker[this.state.service.id]}/v3/service/livestream`, params);

    EventEmitter.emit('/client', '');
		
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
        if( x.data.avatar ) service.avatar = x.data.avatar;
				service.status = true;
				this.setState({service});
				
			}
			this.renderLiveFeed(x.data.stage);
			this.setState({streams: x.data.streams?x.data.streams:[]});
		}

    const PortalStage = EventEmitter.addListener(`/service/stage`, async data => {
			if( data.service === this.state.service.id ) {
				this.renderLiveFeed( data.Stage );
				//this.setState({next: data.Next, socials: data.Socials});
			}
		}); this.setState({PortalStage});

    

    this.setState({livetime: setInterval(()=>{
			/*if( this.state.meta.azura.time === 0 && this.state.meta.rtmp.time === 0 ) {
				this.setState({livetimestamp: `0:00:00`});
				return;
			}*
			let time = Math.floor(Date.now()/1000-(this.state.meta.azura.time > this.state.meta.rtmp.time ? this.state.meta.azura.time : this.state.meta.rtmp.time));
			let h = Math.floor(time / 3600);
    	let m = Math.floor(time % 3600 / 60);
    	let s = Math.floor(time % 3600 % 60);
			this.setState({livetimestamp: `${h}:${m<10?'0'+m:m}:${s<10?'0'+s:s}`});*/

      try {
        let start = new Date(this.state.stage.rtmp.time);
        let time = new Date();
        

        time = Math.abs(time.getTime()/1000-start.getTime()/1000);

        //let time = Math.floor(Date.now()/1000-(this.state.meta.azura.time > this.state.meta.rtmp.time ? this.state.meta.azura.time : this.state.meta.rtmp.time));
        let h = Math.floor(time / 3600);
        let m = Math.floor(time % 3600 / 60);
        let s = Math.floor(time % 3600 % 60);
        this.setState({livetimestamp: `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`});

        //return <>00:01</>
      } catch(error) {
        //return <>00:00</>
      }

		}, 1000)});
		return ()=>{
			clearInterval(this.state.livetime);
		}

    
		
	}

  async renderLiveFeed(feed) {
    //console.log(this.state.stage, feed);
		//feed.select = 1;
		if( feed.select < 10 ) {
			if( Object.keys(feed.live).length>0 ) {}
				//if( window.location.pathname !== '/live/'+feed.live.username.toLowerCase().replaceAll(' ','') ) {
				//}
			//document.title = `${feed.live.djtitle?feed.live.djtitle:feed.live.username} ${feed.live.description?feed.live.description:''} Live - Mix365 Radio`;
		} else {
			//document.title = "Chat / Live Video - Mix365 Radio";
		}

		if( this.state.stage.select === 1 && this.state.stage_temp.select >= 10 && feed.select >= 10 ) {
			this.setState({stage: feed, stage_temp: feed},()=>{
			});
			return;
		}
		if( this.state.stage.select === 1 && feed.select >= 10 ) {
      if( this.state.videoPlaying )
			  this.setState({stage_temp: feed}/*,()=>this.props.dimensions()*/);
      else
        this.setState({stage: feed}/*,()=>this.props.dimensions()*/);
		} else {
      //console.log("triggering here?");
			this.setState({stage: feed, stage_temp: feed}/*,()=>this.props.dimensions()*/);
		}
	}

	onError(event) {
		this.setState({stage: this.state.stage_temp});
	}
  
  async isPlaying(playing) {
    this.setState({videoPlaying: playing});
  }

	render() {
		const user = this.context;

    let totalviewers = this.state.stage.viewers.reduce((n, {viewers}) => n + viewers, 0);
    /*try {
      for( let i in this.state.stage.viewers ) {
        viewers += this.state.stage.viewers[i];
      }

    } catch(error) {

    }*/

    const viewers = this.state.stage.viewers.map((e, i)=>{
      //console.log(e);
      return (
        <li key={i}>
          {e.name}: {e.viewers}
        </li>
      )
    });
    
		return (
			<Row className="gx-0 livestream" style={{backgroundImage: 'url("https://cloud1.ultrastream.io/images/chatbox/light/dynamic-light-silver-background-elegant-flat-vector.jpg")'}}>
        {user.user.admin ?
          <>
            <Col lg={8}>
              <Row className="gx-0">
                {/*<Col xs={12}>
                  <div className="livestream-chatbox-header">
                    <div className="d-flex align-items-center p-2">
                      <div className="me-2 lh-1">
                        <span className="">
                          {this.state.stage.select < 10 ?
                            <img src={this.state.stage.live.avatar?`https://cloud.ultrastream.io/${this.state.stage.live.avatar}?d=${Math.floor(Date.now()/1000)}`:`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="img" width="200" />
                          :
                            <img src={this.state.service.avatar?`https://cloud.ultrastream.io/images/${this.state.service.avatar}?d=${Math.floor(Date.now()/1000)}`:`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="img" width="200" />
                          }
                        </span>
                      </div>
                      <div className="flex-fill">
                        <div className="card-header">
                          {this.state.stage.select < 10 ?
                            <h5>{this.state.stage.live.title?this.state.stage.live.title:this.state.stage.live.usertitle?this.state.stage.live.usertitle:this.state.stage.live.username}</h5>
                          :
                            <h5>{this.state.service.name}</h5>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>*/}
                <Col xs={12}>
                  {this.state.stage.select < 10 ?
                    <>
                      <VideoPlayer
                        id="video"
                        service={this.state.stage.live.service} //{this.state.select.address}
                        //select={this.state.select_temp.select}
                        autoPlay={true}
                        uid={user.user.user.id}
                        theatre={this.theatre}
                        onError={this.onError}
                        height={this.state.meta?.video?.height}
                        isPlaying={this.isPlaying}
                      />
                    </>
                  :
                    <>
                      <img src={`https://cloud.ultrastream.io/images/components/offline.jpg`} width="100%" alt="Stream Offline" />
                    </>
                  }
                </Col>
                <Col xs={12}>
                  <div className="livestream-video-stage">
                    <div className="livestream-video-stage-avatar">
                      {this.state.stage.select < 10 ?
                        <img src={this.state.stage.live.avatar?`https://cloud.ultrastream.io/${this.state.stage.live.avatar}?d=${Math.floor(Date.now()/1000)}`:`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="img" width="200" />
                      :
                        <img src={this.state.service.avatar?`https://cloud.ultrastream.io/images/${this.state.service.avatar}?d=${Math.floor(Date.now()/1000)}`:`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="img" width="200" />
                      }
                      
                    </div>
                    <div style={{width: '100%'}}>
                      
                      <div className="livestream-video-stage-content-header">
                        <div>
                          {this.state.stage.select < 10 ?
                            <h4>{this.state.stage.live.title?this.state.stage.live.title:this.state.stage.live.usertitle?this.state.stage.live.usertitle:this.state.stage.live.username}</h4>
                          :
                            <h4>{this.state.service.name}</h4>
                          }
                          
                        </div>
                        <div style={{marginLeft: 'auto', paddingRight: 10, paddingTop: 10}}>
                          <Button size="sm" variant="light" className="btn-outline-dark" >Follow</Button> <Button size="sm" variant="light" className="btn-outline-dark" >Like</Button> <Button size="sm" variant="light" className="btn-outline-dark" >Notification</Button> <Button size="sm" variant="light" className="btn-outline-dark" >Subscribe</Button>
                        </div>
                      </div>
                      <div className="livestream-video-stage-content-body">
                        <div>
                          <Genres genres={this.state.stage.live.genres} />
                        </div>
                        <div style={{marginLeft: 'auto', paddingRight: 10}}>
                          {this.state.stage.select < 10 &&
                            <div style={{paddingTop: 5, fontWeight: 600}}>
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                show={this.state.showTooltip}
                                overlay={<Popover id="popover-basic" onMouseEnter={()=>this.setState({showTooltip: true})} onMouseLeave={()=>this.setState({showTooltip: false})}>
                                  <Popover.Header as="h3">Viewers</Popover.Header>
                                  <Popover.Body>
                                    <ul className="d-flex mb-0">
                                      {viewers}
                                    </ul>
                                  </Popover.Body>
                                </Popover>}
                              >
                                <span style={{marginRight: 10}} onMouseEnter={()=>this.setState({showTooltip: true})} onMouseLeave={()=>this.setState({showTooltip: false})}>
                                <FontAwesomeIcon icon="user" style={{color: '#FF8280'}} /> {totalviewers} 
                              </span>
                              </OverlayTrigger>
                              
                              <span style={{marginRight: 10}}>
                                <FontAwesomeIcon icon="hourglass-empty" style={{color: '#FF8280'}} /> <span style={{fontFamily: 'Helvetica Neue,sans-serif', fontVariantNumeric: 'tabular-nums'}}>{this.state.livetimestamp}</span>
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="livestream-video-stage-content-footer">
                        
                      </div>
                      <div className="livestream-video-stage-content-footer">
                        
                      </div>
                      
                    </div>
                  </div>
                </Col>
              </Row>
              
            </Col>
            <Col>
              <Chatbox
                service={this.state.service.id}
                category={'live'}
                type={'full'}
              />
            </Col>
          </>
        :
          <>
            <Col md={8}>
          
              <div className="livestream-video-player">
                {this.state.stage.select<=2?
                  <>
                    <VideoPlayer
                      id="video"
                      service={this.state.stage.live.service} //{this.state.select.address}
                      //select={this.state.select_temp.select}
                      autoPlay={true}
                      uid={user.user.user.id}
                      theatre={this.theatre}
                      onError={this.onError}
                      height={this.state.meta?.video?.height}
                    />
                  </>
                :
                  <>
                    <img src={`https://cloud.ultrastream.io/images/components/offline.jpg`} width="100%" alt="Stream Offline" />
                  </>
                }
              </div>
              <div className="livestream-video-stage">
                <div className="livestream-video-stage-avatar">
                  {this.state.stage.select < 10 ?
                    <img src={this.state.stage.live.avatar?`https://cloud.ultrastream.io/${this.state.stage.live.avatar}?d=${Math.floor(Date.now()/1000)}`:`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="img" width="200" />
                  :
                    <img src={this.state.service.avatar?`https://cloud.ultrastream.io/images/${this.state.service.avatar}?d=${Math.floor(Date.now()/1000)}`:`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="img" width="200" />
                  }
                  
                </div>
                <div style={{width: '100%'}}>
                  
                  <div className="livestream-video-stage-content-header">
                    <div>
                      {this.state.stage.select < 10 ?
                        <h4>{this.state.stage.live.title?this.state.stage.live.title:this.state.stage.live.usertitle?this.state.stage.live.usertitle:this.state.stage.live.username}</h4>
                      :
                        <h4>{this.state.service.name}</h4>
                      }
                      
                    </div>
                    <div style={{marginLeft: 'auto', paddingRight: 10, paddingTop: 10}}>
                      <Button size="sm" variant="light" className="btn-outline-dark" >Follow</Button> <Button size="sm" variant="light" className="btn-outline-dark" >Like</Button> <Button size="sm" variant="light" className="btn-outline-dark" >Notification</Button> <Button size="sm" variant="light" className="btn-outline-dark" >Subscribe</Button>
                    </div>
                  </div>
                  <div className="livestream-video-stage-content-body">
                    <div>
                      <Genres genres={this.state.stage.live.genres} />
                    </div>
                    <div style={{marginLeft: 'auto', paddingRight: 10}}>
                      {this.state.stage.select < 10 &&
                        <div style={{paddingTop: 5, fontWeight: 600}}>
                          <span style={{marginRight: 10}}>
                            <FontAwesomeIcon icon="user" style={{color: '#FF8280'}} /> {totalviewers} 
                          </span>
                          <span style={{marginRight: 10}}>
                            <FontAwesomeIcon icon="hourglass-empty" style={{color: '#FF8280'}} /> <span style={{fontFamily: 'Helvetica Neue,sans-serif', fontVariantNumeric: 'tabular-nums'}}>{this.state.livetimestamp}</span>
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="livestream-video-stage-content-footer">
                    
                  </div>
                  <div className="livestream-video-stage-content-footer">
                    
                  </div>
                  
                </div>
                {/*
                <div className="livestream-video-stage-content">
                  <div className="livestream-video-stage-content-header">
                    <div>
                      Name
                    </div>
                    <div style={{alignItems:'flex-end'}}>
                      Buttons
                    </div>
                  </div>
                  <div className="livestream-video-stage-content-body">
                    <div>
                      Content
                    </div>
                    <div>
                      Viewers and streaming
                    </div>
                  </div>
                  <div className="livestream-video-stage-content-footer">
                    Genres / Track currently playing
                  </div>
                </div>*/}
              </div>

            </Col>
            <Col>
              <Chatbox
                service={this.state.service.id}
                category={'live'}
                type={'full'}
              />
            </Col>
          </>
        }
				
			</Row>
		)
	}
}
